import { ReactNode, useEffect } from 'react';

const ScrollToTop = ({ children, location }: { children: ReactNode; location?: { pathname: string } }) => {
    useEffect(() => {
        if (location && location.pathname) {
            window.scrollTo(0, 0);
        }
    }, [location]);
    return children;
};

export default ScrollToTop;
